import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainMenuComponent } from '../main-menu/main-menu.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { Router, RouterModule } from '@angular/router';
import { MsalModule, MsalService } from '@azure/msal-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuthHelperService } from '../services/auth-helper.service';
import { Subject } from 'rxjs';
import { Claim } from '../models/Claim';
import { UserService } from '../services/user.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';

@Component({
  selector: 'app-layout-component',
  templateUrl: './layout-component.component.html',
  styleUrls: ['./layout-component.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatDividerModule,
    MainMenuComponent,
    RouterModule,
    MsalModule,
    MatTooltipModule,
    RouterModule,
    UserAvatarComponent
  ]
})
export class LayoutComponentComponent {
  isIframe = false;
  displayName?: string;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  claims: Claim[] = [];
  initials: string = '';
  username: string = '';
  role: string = '';
  name: string = '';

  constructor(
    private readonly authService: MsalService,
    private readonly router: Router,
    private readonly authServiceHelper: AuthHelperService,
    private readonly userService: UserService,
    private readonly dialog: MatDialog
  ) {}

  async ngOnInit() {
    if (typeof window !== 'undefined') {
      this.isIframe = window !== window.parent && !window.opener;
    }

    this.authService.handleRedirectObservable().subscribe();
    this.loginDisplay = this.authServiceHelper.setLoginDisplay();

    let activeAccount = this.authService.instance.getActiveAccount();
    this.role = await this.userService.fetchUserRole(activeAccount?.idTokenClaims?.oid as string);
    this.userService.setUserRole(this.role);

    if (activeAccount) {
      this.displayName = activeAccount.name;
      this.initials = this.getInitials();
      this.name = this.getName();
      this.username = activeAccount.username;
    }

    this.authService.instance.enableAccountStorageEvents();
  }

  getInitials() {
    let initials = '';
    
    if(this.displayName)
    {
      initials = this.displayName
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase();
    }

    return initials.substring(0, 2);
  }

  getName() {
    return this.displayName? this.displayName : '';
  }



  logout(popup?: boolean) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: '/',
      }).subscribe(() => {
        this.router.navigate(['']);
      });
    } else {
      this.authService.logoutRedirect().subscribe(() => {
        this.router.navigate(['']);
      });
    }
  }

  onLogout(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '300px',
      data: {
        title: 'Logout',
        message: 'Are you sure you want to logout?',
        confirmButtonText: 'Logout',
        cancelButtonText: 'Stay'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.logout();
      }
    });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
